<template>
    <section class="about__container">
        <div class="content">
            <div class="left">
                <slot name="left"></slot>
            </div>
            <div class="right">
                <slot name="right"></slot>
            </div>
        </div>

    </section>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>
.content{
    display: flex;
    gap: 84px;
}
.left{
    min-height: 100%;
}
.left,
.right{
    width: 50%;
    display: flex;
    flex-direction: column;
}

@media (max-width: 1024px) {
.content{
    flex-direction: column;
    gap: 24px;
}
.left,
.right{
    width: 100%;
}
.about__container.leftp .left{
    order: 2;

}
}

</style>